<template>
  <v-btn
      hint="Enviar instruções de alteração de senha"
      icon
      flat
      :loading="loading"
      @click="sentResetPasswordInstruction"
  >
    <v-icon small medium>mdi-refresh</v-icon>
  </v-btn>
</template>

<script>

  import AdminService from '@/services/applications/configurations/AdminService';

  export default {
    name: 'SendResetPasswordInstruction',
    props: ['admin'],
    data() {
      return {
        loading: false,
      };
    },
    methods: {
      sentResetPasswordInstruction() {
        this.loading = true;
        AdminService
          .sendResetPasswordInstruction(this.admin.id)
          .then(() => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'success',
              message: `Instruções de redefinição de senha foram enviadas com sucesso`,
              messageIcon: 'mdi-check',
            });
          })
          .catch(({ response }) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.join(', '),
              messageIcon: 'mdi-alert-circle',
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>

<style scoped lang="scss">
</style>
